/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * The SectionType tells the frontend how the section should be rendered
 * @export
 */
export const SectionTypeConstants = {
    PropertiesListing: 'PropertiesListing',
    Tracking: 'Tracking',
    Table: 'Table',
    Tabs: 'Tabs',
    Dynamic: 'Dynamic',
    LightTable: 'LightTable',
    EntityHierarchy: 'EntityHierarchy',
    PlasmidView: 'PlasmidView'
} as const;
export type SectionTypeConstants = typeof SectionTypeConstants[keyof typeof SectionTypeConstants];


export function SectionTypeConstantsFromJSON(json: any): SectionTypeConstants {
    return SectionTypeConstantsFromJSONTyped(json, false);
}

export function SectionTypeConstantsFromJSONTyped(json: any, ignoreDiscriminator: boolean): SectionTypeConstants {
    return json as SectionTypeConstants;
}

export function SectionTypeConstantsToJSON(value?: SectionTypeConstants | null): any {
    return value as any;
}

